<template>
  <div class="horizontal layout center relative" v-click-outside="closeConnectionGuild">
    <NetworkConnectionGuide v-if="showConnectionGuide" @close="closeConnectionGuild" />
    <div name="connection-tooltip" class="connection-status" @click="toggleConnectionGuide">
      <div
        v-if="isConnectionGoodOrUnstableOrError"
        class="connection-status__body"
        :class="{
          'white': isTextColourLight,
        }"
      >
        <aha-icon
          v-if="connectionStatus === CONNECTION_STATUS.GOOD"
          name="connection-good"
          class="status-good"
          width="24"
          height="24"
          viewBox="0 0 24 24"
        />
        <aha-icon
          v-if="connectionStatus === CONNECTION_STATUS.UNSTABLE"
          name="connection-unstable"
          class="status-unstable"
          width="24"
          height="24"
          viewBox="0 0 24 24"
        />
        <aha-icon
          v-if="connectionStatus === CONNECTION_STATUS.ERROR"
          name="connection-error"
          class="status-error"
          width="24"
          height="24"
          viewBox="0 0 24 24"
        />
      </div>
      <aha-spinner
        :variant="isTextColourLight ? 'white' : 'dark'"
        v-if="connectionStatus === CONNECTION_STATUS.RECONNECTING"
      />
    </div>
    <aha-toggle-tip
      to="connection-tooltip"
      trigger="mouseenter"
      :text="titleConnection"
      theme="dark"
      placement="top-end"
    />
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { CONNECTION_STATUS } from '@/utils/system/SystemConnection'
import NetworkConnectionGuide from './NetworkConnectionGuide.vue'

export default {
  components: {
    NetworkConnectionGuide,
  },
  data() {
    return {
      CONNECTION_STATUS,
      showConnectionGuide: false,
    }
  },
  computed: {
    ...mapGetters('systemConnection', ['connectionStatus', 'userConnectionStatus']),
    ...mapGetters(['isTextColourLight']),
    titleConnection() {
      if (this.connectionStatus === CONNECTION_STATUS.GOOD) {
        return this.$t('Status: <b>Excellent</b>')
      }
      if (this.connectionStatus === CONNECTION_STATUS.UNSTABLE) {
        return this.$t('Status: <b>Unstable</b><br> Some features may not work.')
      }
      if (this.connectionStatus === CONNECTION_STATUS.ERROR) {
        return this.$t('Status: <b>Server error</b>')
      }
      if (this.connectionStatus === CONNECTION_STATUS.RECONNECTING) {
        if (this.userConnectionStatus === CONNECTION_STATUS.ERROR) {
          return this.$t('No internet. Retrying...')
        }
        return this.$t('No internet. Retrying...')
      }

      return ''
    },
    isConnectionGoodOrUnstableOrError() {
      return this.connectionStatus === CONNECTION_STATUS.GOOD ||
        this.connectionStatus === CONNECTION_STATUS.UNSTABLE ||
        this.connectionStatus === CONNECTION_STATUS.ERROR
    },
  },
  watch: {
    connectionStatus() {
      if (this.connectionStatus === CONNECTION_STATUS.RECONNECTING) {
        this.showConnectionGuide = false
      }
    },
  },
  methods: {
    toggleConnectionGuide() {
      if (this.connectionStatus === CONNECTION_STATUS.RECONNECTING) {
        return
      }
      this.showConnectionGuide = !this.showConnectionGuide
    },
    closeConnectionGuild() {
      this.showConnectionGuide = false
    },
  },
}
</script>

<style lang="scss" scoped>
.status-good {
  &::v-deep path[fill="#33C173"] {
    fill: #33C173;
  }
  &::v-deep path[fill="#fff"] {
    fill: #fff;
  }
}
.status-unstable {
  &::v-deep path[fill="#FFA826"] {
    fill: #FFA826;
  }
  &::v-deep path[fill="#282E3E"] {
    fill: #282E3E;
  }
}
.status-error {
  padding-left: 2px;
  &::v-deep path[fill="#FF4954"] {
    fill: #FF4954;
  }
}
.connection-status__body {
  @apply flex items-center justify-center rounded-full;
  width: 32px;
  height: 32px;

  &:hover {
    @apply cursor-pointer;
    background-color: rgba(10, 10, 10, 0.1);
  }
  &:active {
    background-color: rgba(10, 10, 10, 0.2);
  }
  &.white {
    &:hover {
      background-color: rgba(255, 255, 255, 0.2);
    }
    &:active {
      background-color: rgba(255, 255, 255, 0.3);
    }
  }
}
.connection-status {
  @apply w-10 rounded-full flex justify-center;
  &:focus-visible {
    outline: 2px solid #89BEFA;
  }
}
</style>
